// extracted by mini-css-extract-plugin
export default {"wrapper":"AS-z","availablePromoMessagesLabel":"BS-z","promoMessageList":"CS-z","promoMessage":"DS-z","appliedPromoMessage":"ES-z","promoMessageAmount":"FS-z"};